/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  function onClassChange(element, callback) {
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type !== "attributes") {
          continue;
        }
        callback(mutation.target);
      }
    });
    observer.observe(element, {
      attributes: true,
      attributeFilter: ["class"],
    });
    // return observer.disconnect;
  }

  // Add custom code below this line
  const form = document.querySelector("product-form");
  if (form) {
    // initialize the selected variant
    const selectedVariantId = document.querySelector('input[name="id"]').value;
    if (selectedVariantId) {
      document
        .querySelectorAll(`[data-variant-togglable="${selectedVariantId}"]`)
        .forEach((el) => {
          el.classList.remove("hidden");
        });
    }

    // handle variant change, toggle the selected variant visibility
    form.container.addEventListener("theme:variant:change", function (event) {
      const variant = event.detail.variant;
      if (!variant) {
        console.warn("variant data not found");
        return;
      }
      for (const v of form.productJSON.variants) {
        document
          .querySelectorAll(`[data-variant-togglable="${v.id}"]`)
          .forEach((el) => {
            if (v.id !== event.detail.variant.id) {
              el.classList.add("hidden");
            } else {
              el.classList.remove("hidden");
            }
          });
      }
    });
  } else {
    console.warn("product form not found");
  }

  // custom slider for variant selection changing to active image
  const productMediaList = document.querySelector("[data-product-media-list]");

  if (productMediaList) {
    const images = productMediaList.querySelectorAll("[data-image-id]");
    const imagesArray = Array.from(images);

    function hideShowArrows() {
      // hide show arrows when reaching the end or start of the slider
      const nextArrow = productMediaList.querySelector(".slider__button--next");
      const prevArrow = productMediaList.querySelector(".slider__button--prev");
      const currentSlide = imagesArray.findIndex((el) => el.classList.contains("media--active"));
      if (currentSlide === 0) {
        prevArrow.classList.add("hidden");
      } else {
        prevArrow.classList.remove("hidden");
      }
      if(currentSlide === imagesArray.length - 1) {
        nextArrow.classList.add("hidden");
      } else {
        nextArrow.classList.remove("hidden");
      }
    }

    function initialScrollToImage() {
      const activeImage = imagesArray.find((el) => el.classList.contains("media--active"));
      if (activeImage && location.search.includes("variant")) {
        window.requestAnimationFrame(() => {
          productMediaList.scrollTo({
            left: activeImage.offsetLeft,
            behavior: "smooth",
          });
        });
      }
    }

    images.forEach((el) =>
      onClassChange(el, function (node) {
        if (node.classList.contains("media--active")) {
          window.requestAnimationFrame(() => {  
            productMediaList.scrollTo({
              left: node.offsetLeft,
              behavior: "smooth",
            });
            hideShowArrows();
          });
        }
      })
    );
    hideShowArrows(); // run initial check
    initialScrollToImage()
  }

  // add subscribe button trigger listener
  const subscribeWrappers = document.querySelectorAll(".subscribe-wrapper");
  const overlay = document.querySelector("popup-newsletter");
  if (subscribeWrappers && subscribeWrappers.length > 0) {
    subscribeWrappers.forEach((wrapper) => {
      // hide buttons so user knows they have popup disabled in theme editor
      if(!overlay) {
        wrapper.classList.add("hidden");
      } else {
        wrapper.classList.remove("hidden"); // remove just in case theme editor reloads section dynamically
        const button = wrapper.querySelector(".subscribe-trigger");
        button.addEventListener("click", function (event) {
          event.preventDefault();
          overlay.popupOpen();
        });
      }
    });
  } else {
    console.warn("Newsletter popup component not found");
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
